var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuUsers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 15.8333C1.66663 14 3.16663 12.5 4.99996 12.5H8.33329C10.1666 12.5 11.6666 14 11.6666 15.8333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74998 5.00004C9.91665 6.16671 9.91665 8.00005 8.74998 9.08338C7.58331 10.1667 5.74998 10.25 4.66665 9.08338C3.58331 7.91671 3.49998 6.16671 4.58331 5.00004C5.66665 3.83338 7.58331 3.91671 8.74998 5.00004",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.6667H15.8333C17.2499 11.6667 18.3333 12.7501 18.3333 14.1667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 5.5835C16.9167 6.41683 16.9167 7.75016 16.0833 8.50016C15.25 9.25016 13.9167 9.3335 13.1667 8.50016C12.4167 7.66683 12.3333 6.3335 13.1667 5.5835C13.9167 4.8335 15.25 4.8335 16.0833 5.5835",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainMenuUsers);
export default ForwardRef;